exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reports .report-item[data-v-9fffc892]{min-height:330px;height:100%}.icon-box a[data-v-9fffc892]{width:300px;text-decoration:none;height:40px;display:inline-block;padding:5px;margin-right:5px;margin-bottom:5px}.icon-box a img[data-v-9fffc892]{max-height:100%}.chart-item[data-v-9fffc892]{height:64px;position:relative}.empty-text[data-v-9fffc892]{line-height:1.4;display:none;margin-top:5px;padding-right:20px}.mini-graph[data-v-9fffc892]{width:87px;height:40px;background:#ccc;position:absolute;top:0}.mini-graph.centered[data-v-9fffc892]{left:50%;margin-left:-43.5px}", ""]);

// exports
